import React, { createContext, useContext, useState, useCallback } from 'react'
import { Snackbar, Alert } from '@mui/material'

// Definindo o contexto
const SnackbarContext = createContext()

// Hook para usar o contexto
export const useSnackbar = () => {
  const context = useContext(SnackbarContext)

  if (!context) {
    throw new Error('useSnackbar deve ser usado dentro de um SnackbarProvider')
  }

  return context
}

// Componente SnackbarProvider
export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info',
  })

  const showSnackbar = useCallback((message, severity = 'info') => {
    setSnackbar({ open: true, message, severity })
  }, [])

  const hideSnackbar = useCallback(() => {
    setSnackbar(prev => ({ ...prev, open: false }))
  }, [])

  const handleClose = useCallback(() => {
    setSnackbar(prev => ({ ...prev, open: false }))
  }, [])

  const contextValue = {
    showSnackbar,
    hideSnackbar,
    isOpen: snackbar.open
  }

  return (
    <SnackbarContext.Provider value={contextValue}>
      {children}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        onClose={handleClose}
      >
        <Alert
          severity={snackbar.severity}
          variant="filled"
          onClose={handleClose}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  )
}
